import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollObserver = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!("IntersectionObserver" in window)) return;

    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) return;

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: "0px 0px -40px 0px",
      threshold: 0.08,
    });

    // Small delay to allow new route DOM to mount
    const timer = setTimeout(() => {
      const candidates = document.querySelectorAll(
        ".reveal-on-scroll, .section-title, .blog-grid, .concertcardfirst, .cd-card-hover, .message-box, .newscardhover, .tagline-v2, .screen-normal"
      );
      candidates.forEach((el) => {
        if (!el.classList.contains("is-revealed")) {
          el.classList.add("reveal-on-scroll");
          observer.observe(el);
        }
      });
    }, 60);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [pathname]);

  return null;
};

export default ScrollObserver;
